import{styled as m}from"@mui/material/styles";import t from"@mui/material/Checkbox";const i=m(t)((({theme:m})=>({marginRight:m.spacing(4),color:m.palette.black40.main})));export{i as Checkbox};
//# sourceMappingURL=styles.js.map
